export enum TabType{
    PRINTERSANDCASHDRAWERS = 'printersAndCashDrawers',
    PREPSTATIONS = 'prepStations',
    PRINTOUTS = 'printouts',
    CASHDRAWER = 'cashDrawer'
}